import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/core/auth'
import Login from '@/pages/login'
import Changepass from '@/pages/password'
import Home from '@/pages/home'
import Bookings from '@/pages/booking/bookings'
import Tickets from '@/pages/booking/tickets'
import Help from '@/pages/help'
import Mails from '@/pages/mails'
import Calendar from '@/pages/calendar'
import Timeline from '@/pages/timeline/timeline'
import Distance from '@/pages/distance'
import Users from '@/pages/user/users'
import Drivers from '@/pages/driver/drivers'
import Clients from '@/pages/client/clients'
import Insurances from '@/pages/insurance/insurances'
import WalletDriver from '@/pages/wallet/driver'
import WalletClient from '@/pages/wallet/client'
import WalletInsurance from '@/pages/wallet/insurance'
import WalletExpense from '@/pages/wallet/expenses'
import WalletInserts from '@/pages/wallet/inserts'
import Invoices from '@/pages/invoices/clients'
import InvoicesDrivers from '@/pages/invoices/drivers'
import InvoicesInsurances from '@/pages/invoices/insurances'
import Archive from '@/pages/invoices/archive'
import ArchiveDrivers from '@/pages/invoices/archiveDrivers'
import ArchiveInsurances from '@/pages/invoices/archiveInsurances'
import Results from '@/pages/results'
import Destinations from '@/pages/destination/destinations'
import Carecenter from '@/pages/carecenter'
import MyDrivers from '@/pages/location/driver'
import Tracker from '@/pages/location/history'
import Campaign from '@/pages/campaign/overview'
// import Test from '@/pages/test'
import Mcode from '@/pages/insurance/mcode'
import Logs from '@/pages/logs'
import Todo from '@/pages/todo/todo'
import PlanningBooqit from '@/pages/booqit/booqit'
import TransportsBooqit from '@/pages/booqit/transports'
import InvoicesBooqit from '@/pages/booqit/invoices'
import Settings from '@/pages/settings'
//import GoogleDrive from '@/pages/google/drive'
import Admin from '@/pages/admin/admin'
import Daily from '@/pages/daily'
//import TimeSheet from '@/pages/timesheet'
import Transactions from '@/pages/invoices/transaction'
import Denied from '@/pages/denied'

Vue.use(Router)

var routes = [
  {
    path: '/',
    name: 'home',
    component: Daily,
    meta: { requiresAuth: true }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar
  },
  {
    path: '/todo',
    name: 'todo',
    component: Todo
  },
  {
    path: '/daily',
    name: 'daily',
    component: Home
  },
  {
    path: '/distance',
    name: 'distance',
    component: Distance
  },
  {
    path: '/booking',
    name: 'booking',
    component: Bookings,
    meta: { requiresAuth: true }
  },
  {
    path: '/tickets',
    name: 'tickets',
    component: Tickets,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: Users
  },
  {
    path: '/driver',
    name: 'driver',
    component: Drivers,
    meta: { requiresAuth: true }
  },
  {
    path: '/client',
    name: 'client',
    component: Clients,
    meta: { requiresAuth: true }
  },
  {
    path: '/insurances',
    name: 'insurances',
    component: Insurances,
    meta: { requiresAuth: true }
  },
  {
    path: '/mcode',
    name: 'mcode',
    component: Mcode,
    meta: { requiresAuth: true }
  },
  {
    path: '/destination',
    name: 'destination',
    component: Destinations,
    meta: { requiresAuth: true }
  },
  {
    path: '/carecenter',
    name: 'carecenter',
    component: Carecenter,
    meta: { requiresAuth: true }
  },
  {
    path: '/changepass',
    name: 'changepass',
    component: Changepass,
    meta: { requiresAuth: true }
  },
  {
    path: '/walletclient',
    name: 'walletclient',
    component: WalletClient,
    meta: { requiresAuth: true }
  },
  {
    path: '/walletdriver',
    name: 'walletdriver',
    component: WalletDriver,
    meta: { requiresAuth: true }
  },
  {
    path: '/walletinsurrance',
    name: 'walletinsurrance',
    component: WalletInsurance,
    meta: { requiresAuth: true }
  },
  {
    path: '/expenses',
    name: 'expenses',
    component: WalletExpense,
    meta: { requiresAuth: true }
  },
  {
    path: '/inserts',
    name: 'inserts',
    component: WalletInserts,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: Invoices,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoicesDrivers',
    name: 'invoicesDrivers',
    component: InvoicesDrivers,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoiceInsurance',
    name: 'invoiceInsurance',
    component: InvoicesInsurances,
    meta: { requiresAuth: true }
  },
  {
    path: '/archive',
    name: 'archive',
    component: Archive,
    meta: { requiresAuth: true }
  },
  {
    path: '/archiveDrivers',
    name: 'archiveDrivers',
    component: ArchiveDrivers,
    meta: { requiresAuth: true }
  },
  {
    path: '/archiveInsurances',
    name: 'archiveInsurances',
    component: ArchiveInsurances,
    meta: { requiresAuth: true }
  },
  {
    path: '/results',
    name: 'results',
    component: Results,
    meta: { requiresAuth: true }
  },
  {
    path: '/help',
    name: 'help',
    component: Help,
    meta: { requiresAuth: true }
  },
  {
    path: '/timeline',
    name: 'timeline',
    component: Timeline,
    meta: { requiresAuth: true }
  },
  {
    path: '/mail',
    name: 'mail',
    component: Mails,
    meta: { requiresAuth: true }
  },
  {
    path: '/campaign',
    name: 'campaign',
    component: Campaign,
    meta: { requiresAuth: true }
  },
  {
    path: '/myDrivers',
    name: 'myDrivers',
    component: MyDrivers,
    meta: { requiresAuth: true }
  },
  {
    path: '/tracker',
    name: 'tracker',
    component: Tracker,
    meta: { requiresAuth: true }
  },
  {
    path: '/planningBooqit',
    name: 'planningBooqit',
    component: PlanningBooqit,
    meta: { requiresAuth: true }
  },
  {
    path: '/transportsBooqit',
    name: 'transportsBooqit',
    component: TransportsBooqit,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoicesBooqit',
    name: 'invoicesBooqit',
    component: InvoicesBooqit,
    meta: { requiresAuth: true }
  },
  // GoogleDrive
  /*
  {
    path: '/googleDrive',
    name: 'googleDrive',
    component: GoogleDrive,
    meta: { requiresAuth: true }
  },

  {
    path: '/timesheet',
    name: 'timeSheet',
    component: TimeSheet,
    meta: { requiresAuth: true }
  },
  */
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/logs',
    name: 'logs',
    component: Logs,
    meta: { requiresAuth: true }
  },

  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true }
  },

 {
    path: '/transactions',
    name: 'transactions',
    component: Transactions,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/denied',
    name: 'denied',
    component: Denied
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter (to, from, next) {
      Auth.logout()
      next('/login')
    }
  }
]

var router = new Router({ routes })

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !Auth.checkAuth(to.name)) {
    next({path: '/login', query: { redirect: to.fullPath }})
  } else {
    next()
  }
})

export default router
